<template>
    <vue-select
        :value="value"
        @input="handleInput"
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på land</em>
        </template>
    </vue-select>
</template>
<script>
import VueSelect from '@components/Wrappers/VueSelect';
import CountryRepository from '@services/repositories/CountryRepository';

export default {
    name: 'SupplierFilter',
    components: {
        VueSelect,
    },
    props: {
        value: null,
    },
    data() {
        return {
            options: [],
        };
    },
    created() {
        const client = new CountryRepository();
        client.getAll().then((res) => {
            this.options = res.map((item) => ({
                id: item.code,
                label: item.name + ' (' + item.code + ')',
                name: item.name,
            }));
        });
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value);
        },
    },
};
</script>
